/* eslint no-unused-vars:0 */

import axios from "axios";

export const otherIncomes = {
    namespaced: true,
    state: {
        otherIncomes: [],
        newOtherIncome: {
            add_to_growth_account: false,
            id: null,
            income_type: 0,
            individual_id: null,
            inflation_rate: 0,
            name: 'Rental',
            specific_age_to_start: 0,
            specific_age_to_stop: 0,
            specific_year_to_start: 0,
            specific_year_to_stop: 0,
            start_year_formula: 'specific_age',
            stop_year_formula: 'plan_length',
            value: 0,
        },
    },
    actions: {
        loadOtherIncomes ({ commit, getters, rootGetters }) {
            return axios
                .get('/api/household/' + rootGetters['auth/user'].household_id + '/other-incomes')
                .then(response => {
                    commit('setOtherIncomes', response.data.data.otherIncomes);
                    return response;
                })
        },

        saveOtherIncomes({ commit, getters, rootGetters }) {
            getters.otherIncomes.forEach((otherIncome, index) => {
                if (otherIncome.id === null) {
                    axios.post('/api/household/' + rootGetters['auth/user'].household_id + '/other-incomes', otherIncome)
                        .then(response => {
                            const otherIncome = response.data.data.otherIncome;
                            delete otherIncome.individual;
                            commit('updateOtherIncome', { otherIncome, index });
                        });
                } else {
                    axios.put('/api/household/' + rootGetters['auth/user'].household_id + '/other-incomes/' + otherIncome.id, otherIncome)
                        .then(response => {
                            const otherIncome = response.data.data.otherIncome;
                            delete otherIncome.individual;
                            commit('updateOtherIncome', { otherIncome, index });
                        });
                }
            });
        },

        deleteOtherIncome({ commit, getters, rootGetters }, { otherIncome, index }) {
            if (otherIncome.id === null) {
                return commit('deleteOtherIncome', { otherIncome, index });
            }

            return axios
                .delete('/api/household/' + rootGetters['auth/user'].household_id + '/other-incomes/' + otherIncome.id)
                .then(response => {
                    commit('deleteOtherIncome', { otherIncome, index });
                    return response;
                })
        },
    },
    mutations: {
        setOtherIncomes (state, otherIncomes) {
            state.otherIncomes = otherIncomes;
        },
        addOtherIncome(state, person) {
            let newOtherIncome = {...state.newOtherIncome};
            newOtherIncome.individual_id = person.id;
            newOtherIncome.specific_age_to_start = person.current_age;
            state.otherIncomes.push(newOtherIncome);
        },
        deleteOtherIncome(state, { otherIncome, index }) {
            if (otherIncome.id === null) {
                state.otherIncomes.splice(index);
            } else {
                state.otherIncomes = state.otherIncomes.filter(i => i.id !== otherIncome.id);
            }
        },
        updateOtherIncome(state, { otherIncome, index }) {
            state.otherIncomes.splice(index, 1, otherIncome);
        },
    },
    getters: {
        otherIncomes: state => state.otherIncomes,
        personOneOtherIncome: (state, getters, rootState, rootGetters) => state.otherIncomes.find(i => i.individual_id === rootGetters['individuals/personOne'].id),
        personTwoOtherIncome: (state, getters, rootState, rootGetters) => state.otherIncomes.find(i => i.individual_id === rootGetters['individuals/personTwo'].id)
    }
};
